import { Card, Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import './About.css'


const About = () => {
    useEffect(() => {
        AOS.init({
            duration : 1500
        })
        AOS.refresh()
    }, [])

    return (
        <main className='about' id='about'>
            <Container>
                <Row xs={1}>
                    <Col className='my-5'>
                        <Row className='justify-content-center align-items-center'>
                            <Col sm={'12'} md={'6'}>
                                <img data-aos='fade-down' src='./img/img8.jpg' className='img-fluid' alt='Foto 1' />
                            </Col>
                            <Col sm={'12'} md={'6'}>
                                <Card className='card1' data-aos='fade-left'>
                                    <h3>Sobre nosotros</h3>
                                    <p>
                                        TEFRIC es una empresa con más de 20 años de experiencia en el sector 
                                        del Frio Industrial y la Climatización, dentro del sector Industrial, Comercial, 
                                        Farmaceútico y Laboratorios, ofreciendo servicios y soluciones para nuestros 
                                        clientes. Ofrecemos una amplia gama de soluciones para todas las necesidades y 
                                        problemas de nuestros clientes, llevando el proceso desde el inicio hasta el final.
                                    </p>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col className='my-5'>
                        <Row className='justify-content-center align-items-center'>
                            <Col sm={'12'} md={'6'}>
                                <Card className='card2' data-aos='fade-right'>
                                    <h3>Nuestros objetivos</h3>
                                    <p>
                                        TEFRIC tiene como objetivo dar las mejores soluciones y unos 
                                        servicios de Alta Calidad, desarrollados por Profesionales altamente cualificados.
                                    </p>
                                </Card>
                            </Col>
                            <Col sm={'12'} md={'6'}>
                                <img data-aos='fade-down' src='./img/img4.jpg' className='img-fluid' alt='Foto 1' />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default About